import script from "./CustomContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomContainer.vue?vue&type=script&setup=true&lang=js"

import "./CustomContainer.vue?vue&type=style&index=0&id=9131cf4a&lang=css"

const __exports__ = script;

export default __exports__